export default class HorarioFuncionamento {
  de: string;
  ate: string;
  dia: string;
  id_horario_funcionamento: number;
}
